import React from "react"
import PropTypes from "prop-types"

import Button from "../Button/button"

import "./menu.css"

const Menu = ({ currentPage, setCurrentPage }) => {
  return (
    <div className="raphael-menu">
      <Button
        clicked={currentPage === "presentation"}
        text="PRESENTATION"
        switchMode={true}
        action={setCurrentPage.bind(this, "presentation")}
      ></Button>
      <Button
        clicked={currentPage === "projects"}
        text="PROJECTS"
        switchMode={true}
        action={setCurrentPage.bind(this, "projects")}
      ></Button>
      <Button
        clicked={currentPage === "competencies"}
        text="COMPETENCIES"
        switchMode={true}
        action={setCurrentPage.bind(this, "competencies")}
      ></Button>
    </div>
  )
}

Menu.propTypes = {
  currentPage: PropTypes.string,
  setCurrentPage: PropTypes.func,
}

export default Menu
